import { render, staticRenderFns } from "./SyncServices.vue?vue&type=template&id=47fecd1a"
import script from "./SyncServices.vue?vue&type=script&lang=js"
export * from "./SyncServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports